export const DEFAULT_MESSAGE_ERROR = "오류가 발생했습니다.";

export const bankOptions = [
  { label: "은행 선택", value: "" },
  ...[
    "국민은행",
    "기업은행",
    "농협은행",
    "신한은행",
    "산업은행",
    "씨티은행",
    "우리은행",
    "하나은행",
    "SC은행",
    "카카오뱅크",
    "케이뱅크",
    "토스뱅크",
    "경남은행",
    "광주은행",
    "대구은행",
    "미래에셋",
    "부산은행",
    "산림조합",
    "새마을금고",
    "수협중앙회",
    "신협",
    "우체국",
    "저축은행",
    "전북은행",
    "제주은행",
  ].map((b) => ({ label: b, value: b })),
];

export const qnaSearchTypeOptions = [
  { label: "제목", value: "title" },
  { label: "작성자명", value: "authorName" },
  { label: "작성자ID", value: "authorID" },
  { label: "답변자명", value: "responderName" },
  { label: "답변자ID", value: "responderID" },
  { label: "내용", value: "content" },
];

export const transferSearchTypeOptions = [
  { label: "제목", value: "title" },
  { label: "답변자명", value: "responderName" },
  { label: "답변자ID", value: "responderID" },
  { label: "이관자명", value: "transfererName" },
  { label: "이관자ID", value: "transfererID" },
  { label: "내용", value: "content" },
];

export const monitoringSearchTypeOptions = [
  { label: "제목", value: "title" },
  { label: "답변자명", value: "responderName" },
  { label: "답변자ID", value: "responderID" },
  { label: "검수자명", value: "monitorName" },
  { label: "검수자ID", value: "monitorID" },
  { label: "내용", value: "content" },
];

export const onGoingQnaSearchTypeOptions = qnaSearchTypeOptions.filter(
  ({ value }) => !value.includes("responder"),
);

export const questionTypeOptions = [
  { label: "유형선택", value: "all" },
  { label: "강좌", value: "강좌" },
  { label: "교재", value: "교재" },
  { label: "학습법", value: "학습법" },
  { label: "기타", value: "기타" },
  { label: "공지", value: "공지" },
];

export const subjectTypeOptions = [
  { label: "과목 전체", value: "all" },
  { label: "국어종합", value: "국어종합" },
  { label: "비문학", value: "비문학" },
  { label: "문학", value: "문학" },
  { label: "운문문학", value: "운문문학" },
  { label: "산문문학", value: "산문문학" },
  { label: "화법·작문", value: "화법·작문" },
  { label: "독서", value: "독서" },
  { label: "문법", value: "문법" },
  { label: "현대문학", value: "현대문학" },
  { label: "고전문학", value: "고전문학" },
  { label: "EBS 분석(공통)", value: "EBS 분석(공통)" },
  { label: "국어", value: "국어" },
];

export const onGoingStatusOptions = [
  { label: "전체", value: "all" },
  { label: "대기중", value: "대기중" },
  { label: "작성중", value: "작성중" },
];

export const completedStatusOptions = [
  { label: "전체", value: "all" },
  { label: "완료", value: "답변 완료" },
  { label: "경고", value: "경고" },
];

export const onGoingMonitoringStatusOptions = [
  { label: "전체", value: "all" },
  { label: "대기중", value: "대기중" },
  { label: "검수중", value: "검수중" },
];

export const completedMonitoringStatusOptions = [
  { label: "전체", value: "all" },
  { label: "완료", value: "완료" },
  { label: "재답변", value: "재답변" },
];

export const faqTypesOptions = [
  { label: "전체 유형", value: "all" },
  { label: "강좌", value: "강좌" },
  { label: "교재", value: "교재" },
  { label: "학습법", value: "학습법" },
  { label: "기타", value: "기타" },
];

export const noticeTypesOptions = [
  { label: "전체 유형", value: "all" },
  { label: "공지", value: "공지" },
  { label: "공지(긴급)", value: "공지(긴급)" },
  { label: "정오(교재) ", value: "정오(교재)" },
  { label: "정오(강의)", value: "정오(강의)" },
];

export const noticeSearchTypeOptions = [
  { label: "제목", value: "title" },
  { label: "작성자", value: "author" },
  { label: "내용", value: "content" },
];

export const questionDifficultyOptions = [
  { label: "난이도 선택", value: "" },
  { label: "쉬움(5분 이내 처리 가능)", shortLabel: "쉬움", value: "쉬움" },
  { label: "중간(10분 이내 처리 가능)", shortLabel: "중간", value: "보통" },
  { label: "어려움(10분 초과 소요)", shortLabel: "어려움", value: "어려움" },
  {
    label: "답변 불가(행정 등 기타사항)",
    shortLabel: "답변 불가",
    value: "답변 불가",
  },
];

export const questionAnswerTypeOptions = [
  { label: "유형 전체", value: "" },
  { label: "독서(교재)", value: "독서(교재)" },
  { label: "문학(교재)", value: "문학(교재)" },
  { label: "화작,매체(교재)", value: "화작,매체(교재)" },
  { label: "문법(교재)", value: "문법(교재)" },
  { label: "독서(강의)", value: "독서(강의)" },
  { label: "문학(강의)", value: "문학(강의)" },
  { label: "화작,매체(강의)", value: "화작,매체(강의)" },
  { label: "문법(강의)", value: "문법(강의)" },
  {
    label: "기타(행정, 학습법 등)",
    value: "기타(행정, 학습법 등)",
    shortLabel: "기타",
  },
];

export const connectionStatusOptions = [
  { label: "접속 상태", value: "all" },
  { label: "접속중", value: "1" },
  { label: "미접속", value: "0" },
];

export const linkingStatusOptions = [
  { label: "연동상태", value: "all" },
  { label: "연동됨", value: "1" },
  { label: "미연동", value: "0" },
];

export const userSearchTypeOptions = [
  { label: "이름", value: "name" },
  { label: "아이디", value: "userId" },
  { label: "전화번호", value: "phone" },
  { label: "대성 아이디", value: "daesungId" },
];
